// Define the openGiftListModal() function
function openGiftListModal() {
    var modal = document.getElementById("gift-list-popup-modal");
    var closeBtn = modal.querySelector(".gift-list-popup-modal-close");
    var stickyAtc = document.querySelector(".m-sticky-addtocart");
    var htmla = document.documentElement;

    function openGiftList() {
        modal.style.display = "block";
        htmla.classList.add("prevent-scroll");
        if (stickyAtc) {
            stickyAtc.classList.add("hidden_important");
        }
    }

    function closeGiftList() {
        modal.style.display = "none";
        htmla.classList.remove("prevent-scroll");
        if (stickyAtc) {
            stickyAtc.classList.remove("hidden_important");
        }
    }

    openGiftList();

    closeBtn.onclick = closeGiftList;

    window.onclick = function(event) {
        if (event.target == modal) {
            closeGiftList();
        }
    };
}

// Define the openFreeGiftModal() function
function openFreeGiftModal() {
    var modal = document.getElementById("free-gift-popup-modal");
    var closeBtn = modal.querySelector(".free-gift-popup-modal-close");
    var stickyAtc = document.querySelector(".m-sticky-addtocart");
    var htmla = document.documentElement;

    function openFreeGift() {
        modal.style.display = "block";
        htmla.classList.add("prevent-scroll");
        if (stickyAtc) {
            stickyAtc.classList.add("hidden_important");
        }
    }

    function closeFreeGift() {
        modal.style.display = "none";
        htmla.classList.remove("prevent-scroll");
        if (stickyAtc) {
            stickyAtc.classList.remove("hidden_important");
        }
    }

    openFreeGift();

    closeBtn.onclick = closeFreeGift;

    window.onclick = function(event) {
        if (event.target == modal) {
            closeFreeGift();
        }
    };
}

function attachButtonClickEvent(buttonId, modalFunction) {
    var button = document.getElementById(buttonId);
    if (button) {
        button.addEventListener("click", modalFunction);
    }
}

function checkAndAttachClickEvents() {
    attachButtonClickEvent("gift-list-more-button", openGiftListModal);
    attachButtonClickEvent("note-gift-list_more_button", openGiftListModal);
    attachButtonClickEvent("free-gift-more-button", openFreeGiftModal);
    attachButtonClickEvent("note-free-gift_more_button", openFreeGiftModal);
}

document.addEventListener("DOMContentLoaded", function() {
    checkAndAttachClickEvents();

    var lastPrice = document.querySelector('.m-cart__subtotal--price .money').innerText;

    var observer = new MutationObserver(function(mutationsList, observer) {
        var currentPrice = document.querySelector('.m-cart__subtotal--price .money').innerText;
        if (currentPrice !== lastPrice) {
            checkAndAttachClickEvents();
            lastPrice = currentPrice;
        }
    });

    var config = { childList: true };

    observer.observe(document.querySelector('.m-cart__subtotal--price'), config);
});

(function() {
  var modal = document.getElementById('free-gift-popup-modal');
  //console.log('Modal:', modal);

  var links = modal.querySelectorAll('a');
  links.forEach(function(link) {
    link.addEventListener('click', function(e) {
      //console.log('Link clicked:', link);
      e.preventDefault();
    });
  });

  var buttons = modal.querySelectorAll('button');
  var htmla = document.documentElement;
  buttons.forEach(function(button) {
    if (button.classList.contains('m-product-quickview-button')) {
      button.addEventListener('click', function() {
        //console.log('Button clicked:', button);
        modal.style.display = "none";
        htmla.classList.remove("prevent-scroll");
      });
    }
  });
})();

(function() {
  var hasGift = false;
  var cartDrawer = null;

  function checkCartForFreeGift() {
    fetch('/cart.js').then(function(response) {
      return response.json();
    }).then(function(cart) {
      //console.log('Cart:', cart);
      var cartTotal = cart.total_price;
      hasGift = cart.items.some(function(item) {
        return item.product_type === 'free_gift';
      });
      if (cart.total_price < 4900 && hasGift) {
        cart.items.forEach(function(item) {
          if (item.product_type === 'free_gift') {
            var newQuantity = 0;
            var requestData = {
              updates: {
                [item.variant_id]: newQuantity
              }
            };
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: requestData,
              dataType: 'json',
              success: function(cart) {
                //console.log('Cart updated:', cart);
                updateCartItems();

                // 在成功回调里，检查购物车抽屉是否存在，并更新抽屉的UI。
                if (cartDrawer) {
                  cartDrawer.onCartDrawerUpdate();
                }
              },
              error: function(jqXHR, textStatus, errorThrown) {
                 //console.error('Error updating cart:', textStatus, errorThrown);
              }
            });
          }
        });
      }
      toggleFreeGiftTipsBox(cartTotal, hasGift);
    }).catch(function(error) {
      //console.error('Error fetching cart data:', error);
    });
  }

  function updateCartItems() {
    fetch('/cart').then(function(response) {
      return response.text();
    }).then(function(html) {

// Trigger cart update using Shopify.onCartUpdate
      var cart = window.Shopify.cart;
      window.Shopify.onCartUpdate(cart);
      var cartTotal = parseFloat(document.querySelector('.m-cart__subtotal--price .money').textContent.replace(/[^\d.-]/g, ''));
      toggleFreeGiftTipsBox(cartTotal, hasGift);
    }).catch(function(error) {
      //console.error('Error updating cart items:', error);
    });
  }

  function toggleFreeGiftTipsBox(cartTotal, hasGift) {

    //console.log('Cart Total:', cartTotal);
    //console.log('Has Gift:', hasGift);

    var giftlist = document.getElementById('freegiftTipsBox-giftlist');
    var freegift = document.getElementById('freegiftTipsBox-freegift');

    if (cartTotal < 4900) {
      giftlist.classList.remove('hidden-im');
      freegift.classList.add('hidden-im');
    } else {
      if (hasGift) {
        giftlist.classList.remove('hidden-im');
        freegift.classList.add('hidden-im');
      } else {
        giftlist.classList.add('hidden-im');
        freegift.classList.remove('hidden-im');
      }
    }
  }

  function checkCart() {
    var numItems = document.querySelector('.m-cart__subtotal-itemnum');
    if (numItems) {
      var numItemsText = numItems.innerText;
      if (numItemsText !== prevNumItems) {
        prevNumItems = numItemsText;
        checkCartForFreeGift();
        cartDrawer = document.querySelector("m-cart-drawer");
      }
    }
  }

  var prevNumItems = 0;
  var checkCartInterval = setInterval(checkCart, 100);
  checkCartForFreeGift(); 
})();